import DataTable from '../DataTable';
import { ShowIf } from '../Security/security';

const IpaffsRiskCategorisationTable = ({
  dth,
  data,
  updateData,
  setPaginationLoaded,
  persist,
  setPersist,
  setNewRiskCategory,
  lastUpdated,
}) => {
  const columns = [
    {
      colKey: 'hsCode',
      header: 'HS Code',
      searchOpts: { type: 'text', sendAs: 'hsCode' },
      fixedWidth: '10%',
    },
    {
      colKey: 'ipaffsCode',
      header: 'IPAFFS HS Code',
      searchOpts: { type: 'text', sendAs: 'ipaffsCode' },
      fixedWidth: '15%',
    },
    {
      colKey: 'hsDesc',
      header: 'Description',
      searchOpts: { type: 'text', sendAs: 'hsDesc' },
      fixedWidth: '35%',
    },
    {
      colKey: 'riskCat',
      header: 'Risk Category',
      searchOpts: { type: 'text', sendAs: 'riskCat' },
      fixedWidth: '20%',
    },
    {
      colKey: 'catDesc',
      header: 'Risk Category Description',
      searchOpts: { type: 'text', sendAs: 'catDesc' },
      fixedWidth: '20%',
    },
  ];
  const renderColumns = () => {
    return data ? (
      columns.map((col) => (
        <DataTable.Column
          key={col.colKey}
          colKey={col.colKey}
          header={col.header}
          searchOpts={col.searchOpts}
          fixedWidth={col.fixedWidth}
        />
      ))
    ) : (
      <></>
    );
  };

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto auto' }}>
        <h1 className="floating-box-header-general">IPAFFS Risk Categorisation</h1>
        <p className="floating-box-header-general" style={{ fontSize: '1rem', alignItems: 'end', marginRight: '15px' }}>
          Last Updated: {lastUpdated}
        </p>
      </div>

      <div className="px-3 pt-4">
        <DataTable
          handle={dth}
          lazyLoading
          filterable
          sortable
          data={data}
          className="table-striped fixed-table-size"
          advancedSearch
          showAdvnSearch={true}
          onUpdate={updateData}
          onPaginationLoaded={() => {
            setPaginationLoaded(true);
          }}
          persistGetter={persist}
          persistSetter={setPersist}
        >
          <DataTable.Head>
            <ShowIf
              or={[
                { department: 'OPS', role: 'SUPERUSER' },
                { department: 'QA', role: 'SUPERUSER' },
                { department: 'CMT' },
              ]}
            >
              <section className="d-flex justify-content-end datatable-button">
                <button
                  type="button"
                  className="stepper-button yellow"
                  onClick={() => {
                    setNewRiskCategory({});
                  }}
                >
                  Upload
                </button>
              </section>
            </ShowIf>
          </DataTable.Head>
          <DataTable.Pagination itemsPerPage={[10, 15, 50]} areaPadding={'0px'} />
          {renderColumns()}
        </DataTable>
      </div>
    </>
  );
};

export default IpaffsRiskCategorisationTable;
